import { ChangeDetectionStrategy, Component, inject, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';
import { TsButtonModule } from 'tsui';
import { Observable } from 'rxjs';
import { slideInOutHeight } from '@shared/functions/animation.functions';
import { TsSelectModule } from 'tsui/lib/ts-select/ts.select.module';
import { ProjectTemplateService } from '@modules/projects/project-template.service';
import { RelatedToType } from '@shared/enums';
import { ProjectTemplate } from '@modules/projects/projects.types';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-layout-picker-modal',
  standalone: true,
  imports: [
    MatLegacyFormFieldModule,
    ReactiveFormsModule,
    TsDialogComponent,
    TsButtonModule,
    TsSelectModule,
    AsyncPipe,
  ],
  templateUrl: './layout-picker-modal.component.html',
  styleUrl: './layout-picker-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideInOutHeight],
})
export class LayoutPickerModalComponent {
  form = new FormGroup({ template_id: new FormControl() });
  templates$: Observable<ProjectTemplate<any>[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { template_id: number; relatedTo: RelatedToType | string },
    readonly matDialogRef: MatDialogRef<LayoutPickerModalComponent>,
  ) {
    this.templates$ = inject(ProjectTemplateService).get<any>(data.relatedTo);
    this.form.patchValue({ template_id: data.template_id });
  }

  save(): void {
    this.matDialogRef.close(this.form.getRawValue());
  }
}
